export default __webpack_public_path__ + "static/media/loader.df1e3eaf.gif";